import React from "react";
import { TextField } from "react-aria-components";

import type { BaseTextFieldProps } from "@/ui2/molecules/TextField";
import { cn } from "@/lib/helpers/cn";
import { FieldError2 } from "@/ui2/atoms/FieldError";
import { inputStyles } from "@/ui2/molecules/TextField";
import { Label2 } from "@/ui2/atoms/Label";
import { PhoneNumberInput, type PhoneNumberInputProps } from "@/ui2/molecules/PhoneNumberInput";
import { Text2 } from "@/ui2/atoms/Text";

type PhoneNumberTextFieldProps = {
  phoneNumberInputProps?: PhoneNumberInputProps;
} & BaseTextFieldProps;

export function PhoneNumberTextField(props: PhoneNumberTextFieldProps) {
  const {
    className,
    description,
    errorMessage,
    hasStrongLabel,
    isInvalid,
    isReadOnly,
    isRequired,
    label,
    phoneNumberInputProps: { className: classNamePhoneNumber, ...otherPhoneNumberProps } = {},
    ...otherProps
  } = props;

  const { field } = inputStyles();
  const variant = isReadOnly ? "readOnly" : "default";

  return (
    <TextField className={cn(field(), className)} isInvalid={isInvalid} {...otherProps}>
      <Label2
        className={hasStrongLabel ? "tw:font-bold" : ""}
        isInvalid={isInvalid}
        isRequired={isRequired}
        label={label}
      />

      <PhoneNumberInput
        className={classNamePhoneNumber}
        variant={variant}
        {...otherPhoneNumberProps}
      />

      <FieldError2>{errorMessage}</FieldError2>

      {description && !isInvalid && <Text2 slot="description" text={description} />}
    </TextField>
  );
}
